import AddCategoryPage from "./pages/AddCategoryPage";
import AddPostPage from "./pages/AddPostPage";
import CategoriesPage from "./pages/CategoriesPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import PostsPage from "./pages/PostsPage";
import { Routes, Route } from "react-router-dom";
import { ProtectLoginRoute, ProtectMainRoute } from "./components/ProtectRoute";
import EditPostPage from "./pages/EditPostPage";
import EditCategoryPage from "./pages/EditCategoryPage";
import "./App.css";

function App() {
	return (
		<div>
			<Routes>
				<Route
					path="/login"
					element={
						<ProtectLoginRoute>
							<LoginPage />
						</ProtectLoginRoute>
					}
				/>
				<Route
					path="/"
					element={
						<ProtectMainRoute>
							<HomePage />
						</ProtectMainRoute>
					}>
					<Route path="" element={<PostsPage />} />
					<Route path="users/register" element={<RegisterPage />} />
					<Route path="categories" element={<CategoriesPage />} />
					<Route path="categories/new-category" element={<AddCategoryPage />} />
					<Route path="posts/new-post" element={<AddPostPage />} />
					<Route path="posts/edit-post/:postId" element={<EditPostPage />} />
					<Route path="categories/edit-category/:categoryId" element={<EditCategoryPage />} />
				</Route>
			</Routes>
		</div>
	);
}

export default App;
